import React, { Component } from 'react';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';
import { connect } from 'react-redux';
import { loadDBList } from '../../../database/database.actions';
import Auth from '../../../../auth/auth';


const auth = new Auth();

class Step1DataSource extends Component {
  componentDidMount() {
    const orgId = auth.getOrgId();
    this.props.loadDBConnections(orgId);
  }

  handleConnectionSelect = (event) => {
    const connection = this.props.dbList.find(conn => conn.connId === event.target.value);
    this.props.onUpdate({
      selectedConnection: connection,
      selectedSchema: null
    });
  }

  render() {
    const { selectedConnection, dbList, isLoading } = this.props;

    return (
      <div className="step1-container">
        <div className="source-section">
          <h3>Select Database Connection</h3>
          {isLoading && isLoading.includes('dblist') ? (
            <div className="loading-state">
              <CircularProgress size={40} />
              <p>Loading database connections...</p>
            </div>
          ) : dbList && dbList.length > 0 ? (
            <FormControl fullWidth style={{ textAlign: 'left' }}>
              <InputLabel>Choose a database connection</InputLabel>
              <Select
                value={selectedConnection?.connId || null}
                onChange={this.handleConnectionSelect}
                SelectDisplayProps={{'data-testid': 'dd-connection-select'}}
              >
                {dbList.map((conn) => (
                  <MenuItem key={conn.connId} value={conn.connId}>
                    {conn.name}{conn.dbType ? ` — ${conn.dbType}` : ''}{conn.server ? ` (${conn.server})` : ''}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ) : null}

          {(!dbList || dbList.length === 0) ? (
            <div className="empty-state">
              <span className="material-icons">storage</span>
              <p>No database connections available</p>
              <p className="empty-state-hint">Please create a database connection first in the Super User Panel</p>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dbList: state.databaseReducer.dbList,
    isLoading: state.databaseReducer.isLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadDBConnections: (orgId) => {
      dispatch(loadDBList(orgId));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Step1DataSource);
